// ACTIONS
export const FETCH_ACCOUNT = 'FETCH_ACCOUNT';
export const FETCH_ACCOUNT_BY_ID = 'FETCH_ACCOUNT_BY_ID';
export const GET_IS_MANAGED_ACCOUNT = 'GET_IS_MANAGED_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const UPDATE_INVOICING_DETAILS = 'UPDATE_INVOICING_DETAILS';
export const RESET_INVOICING_DETAILS = 'RESET_INVOICING_DETAILS';
export const FETCH_INVOICING_DETAILS = 'FETCH_INVOICING_DETAILS';
export const FETCH_ALL_USERS_IN_ROLE = 'FETCH_ALL_USERS_IN_ROLE';
export const GET_USER_EMAIL_EXIST = 'GET_USER_EMAIL_EXIST';
export const UPDATE_AVATAR_COLOUR = 'UPDATE_AVATAR_COLOUR';

// MUTATIONS
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_INVOICING_DETAILS = 'SET_INVOICING_DETAILS';
export const RESET_ACCOUNT = 'RESET_ACCOUNT';
export const SET_SHAREES_COUNT = 'SET_SHAREES_COUNT';
export const SET_INVOICING_ID = 'SET_INVOICING_ID';
export const SET_AVATAR_COLOUR = 'SET_AVATAR_COLOUR';
